import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-up",
  "use": "icon-up-usage",
  "viewBox": "0 0 9 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9 12\" fill=\"none\" id=\"icon-up\">\n<path d=\"M4.5 0L0 5.79343L2.99957 5.78571V11.5714H5.98371L6.00043 5.78571H9L4.5 0Z\" fill=\"#F91D1D\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol